import { useNavigate } from 'react-router-dom';
import { StageSnapshot } from '../ExecCohort/StageSnapshot';
import { CohortJourney } from '../ExecCohort/CohortJourney';
import './styles.css';

// Patients drill = two distinct lenses:
//  TOP  — point-in-time STOCK (StageSnapshot): how many at each stage as-of any date.
//  BOTTOM — forward FLOW (CohortJourney): of a cohort that did X in month M, who
//           progressed to each next milestone + why those who stalled didn't.
// Both reconstructed from meeting milestones via meetings_raw.patient_id.

export default function ExecPatients() {
  const navigate = useNavigate();
  return (
    <div className="pat-wrap">
      <div className="pat-header">
        <div className="pat-title-block">
          <button className="pat-back-btn" onClick={() => navigate('/exec')}>← חזרה</button>
          <h1 className="pat-title">מסע המטופל</h1>
        </div>
      </div>

      {/* TOP — point-in-time stock */}
      <div className="pat-part">
        <StageSnapshot />
      </div>

      {/* BOTTOM — forward cohort funnel (now includes the cyclic next-stages sequence) */}
      <div className="pat-part">
        <CohortJourney />
      </div>

      <div className="pat-cta">
        <div className="pat-cta-text">
          <strong>למשפך מטופלים מפורט</strong> · חלוקה לפי שלב טיפול, לפי קופה, רשימת מטופלים פר שלב, זמני המתנה
        </div>
        <button className="pat-cta-btn" onClick={() => navigate('/patients-full')}>
          לדשבורד מטופלים מלא ←
        </button>
      </div>
    </div>
  );
}
